import script from "./SkyLazy.vue?vue&type=script&setup=true&lang=js"
export * from "./SkyLazy.vue?vue&type=script&setup=true&lang=js"

import "./SkyLazy.vue?vue&type=style&index=0&id=17dcb132&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17dcb132"]])

export default __exports__